import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import StripeCheckout from 'react-stripe-checkout';
import firebase from 'firebase';
import Footer from '../components/Footer';
import ButtonAppBar from '../components/ButtonAppBar';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  appBar: {
    position: 'relative',
  },
  toolbarTitle: {
    flex: 1,
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(900 + theme.spacing.unit * 3 * 2)]: {
      width: 900,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  heroContent: {
    maxWidth: 600,
    margin: '0 auto',
    padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[200],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing.unit * 2,
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      paddingBottom: theme.spacing.unit * 2,
    },
  },
  footer: {
    marginTop: theme.spacing.unit * 8,
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit * 6}px 0`,
  },
});

const tiers = [
  {
    title: 'Watchman',
    price: '900',
    description: ['10 photos analyzed', 'Tier 1 Results Only', 'Full Matching Images Shown', 'Email support'],
    buttonText: 'Try us out',
    buttonVariant: 'outlined',
  },
  {
    title: 'Defender',
    subheader: 'Most popular',
    price: '2900',
    description: [
      '30 photos analyzed',
      'Tier 2 Results',
      'Full Matching Images Shown',
      'Pages With Matching Images',
      'email support',
    ],
    buttonText: 'Get Started',
    buttonVariant: 'contained',
  },
  {
    title: 'Guardian',
    price: '7900',
    description: [
      '100 photos analyzed',
      'Tier 3 Results: All Results Shown',
      'Full Matching Images',
      'Pages With Matching Images',
      'Partial Matching Images',
      'Phone & email support',
    ],
    buttonText: 'Buy Now!',
    buttonVariant: 'outlined',
  },
  // {
  //   title: 'Overwatch',
  //   price: 'Contact Us',
  //   description: [
  //     '1000+ photos analyzed?',
  //   ],
  //   buttonText: 'Call us',
  //   buttonVariant: 'outlined',
  // },
];


class Pricing extends React.Component {

  state = {
    userEmail: 'testEmail@gmail.com',
    selected: null
  }

  componentDidMount = () => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) { 
        this.setState({ userEmail: user.email}) 
      }
    })
  }

  routeChange = (route) => {
    this.props.history.push(route);
  }

  onToken = (response, price) => {
    console.log('I got a res from stripe', response)
    firebase.auth().onAuthStateChanged(user => {
      let userId = user.uid;
      if (user) {
        firebase.firestore().collection('stripe_customers').doc(userId).collection('tokens').add({token: response.id, amount: price}).then(() => {
          this.newCreditCard = {
            number: '',
            cvc: '',
            exp_month: 1,
            exp_year: 2017,
            address_zip: ''
          };
        });
        // firebase.firestore().collection('stripe_customers').doc(userId).collection('charges').add({
        //   source: response.id,
        //   amount: 35.00
        // });
        setTimeout(() => {
          //do this after
          this.props.history.push('/dashboard')
        }, 1500)
      }
    })
  }


  
  render() {
    const { classes } = this.props;
  


    return (
      <React.Fragment>
        <CssBaseline />

        <AppBar position="static">
          <Toolbar style={{flexDirection: 'row', justifyContent: 'space-between'}}>
            <Typography style={{cursor: 'pointer'}} onClick={() => this.routeChange('/dashboard')} variant="h6" color="inherit" >
              Where's My Art?
            </Typography>
            <Typography style={{cursor: 'pointer'}} onClick={() => this.routeChange('/dashboard')} variant="h6" color="inherit" >
              My Dashboard
            </Typography>
           {/* <Button onClick={this.handleLogout} color="inherit">Logout</Button> */}
          </Toolbar>
        </AppBar>
        
        
        <main className={classes.layout}>
          {/* Hero unit */}
          <div className={classes.heroContent}>
            <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
              Image Credits
            </Typography>
            <Typography variant="h6" align="center" color="textSecondary" component="p">
              Use these credits to unlock your arts online location. We show you the first 3 results for free. 
              To see the you rest you will need to upgrade.
            </Typography>
          </div>
          {/* End hero unit */}
          <Grid container spacing={40} alignItems="flex-end">
            {tiers.map(tier => (
              // Enterprise card is full width at sm breakpoint
              <Grid item key={tier.title} xs={12} sm={tier.title === 'Enterprise' ? 12 : 6} md={4}>
                <Card>
                  <CardHeader
                    title={tier.title}
                    subheader={tier.subheader}
                    titleTypographyProps={{ align: 'center' }}
                    subheaderTypographyProps={{ align: 'center' }}
                    action={tier.title === 'Pro' ? <StarIcon /> : null}
                    className={classes.cardHeader}
                  />
                  <CardContent>
                    <div className={classes.cardPricing}>
                      <Typography component="h2" variant="h3" color="textPrimary">
                        ${tier.price / 100}
                      </Typography>
                      {/*<Typography variant="h6" color="textSecondary">
                        /mo
                      </Typography>*/}
                    </div>
                    {tier.description.map(line => (
                      <Typography variant="subtitle1" align="center" key={line}>
                        {line}
                      </Typography>
                    ))}
                  </CardContent>
                  <CardActions className={classes.cardActions}>
                  <StripeCheckout 
                    amount={tier.price}
                    name="WheresMyArt"
                    description={tier.title}
                    //image={}
                    stripeKey="pk_test_E0NSLjzoKriWDiXE2SPkWMU000fQUCjDMS"
                    currency="USD"
                    email={this.state.userEmail}
                    token={(res) => this.onToken(res, tier.price)}
                  >
                    <Button fullWidth variant={tier.buttonVariant} color="primary">
                      {tier.buttonText}
                    </Button>
                    {/* <button
                        style={{"background-color:#6772E5;color:#FFF;padding:8px 12px;border:0;border-radius:4px;font-size:1em"}}
                        id="checkout-button-plan_F4NxmkeHb52YOF"
                        role="link"
                      >
                        Stripe Provided Checkout
                    </button>*/}
                  </StripeCheckout>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Footer />
        </main>
        
      </React.Fragment>
    );
  }
}

Pricing.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Pricing);
